export default __webpack_public_path__ + "static/media/sonata-cowork.e5d626b6.png";